import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';

export function EmailDistListListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailDistListListing', {
		url: '/admin/distlist',
		controllerAs: 'vm',
		controller: EmailDistListListingCtrl,
		templateUrl: '/ng/hub/Email/DistList/Listing/EmailDistListListingCtrl.html?' + window.BUILD,
		permission: ['manage_groups'],
		resolve: {
			lists: ApiResourcify.endpoint('/distribution_lists'),
			$title: () => 'Email Distribution Lists',
		},
	});
}

export class EmailDistListListingCtrl {
	constructor(Api, $state, modal, lists) {
		'ngInject';
		this.Api = Api;
		this.$state = $state;
		this.modal = modal;
		this.lists = ensure.array(lists).filter(list => list.is_active);
		this.columns = [
			{ field: 'name', label: 'Name', sortable: false },
			{ field: 'num_members', label: 'Number of Contacts', sortable: false },
		];
		this.actions = [
			{ label: 'Edit', icon: null, callback: this.edit.bind(this) },
			{ label: 'Delete', icon: null, callback: this.delete.bind(this) },
		];
		this.provider = this.provideLists.bind(this);
		this.filters = {};
	}

	addNew() {
		this.modal.prompt({ text: 'Distribution List Name:', submitOnEnter: true }).then(name => {
			this.Api.create('/distribution_lists', { name }).then(id => {
				const refresh = this.refresh.bind(this);
				this.modal
					.state('hub.loggedin.EmailDistListEdit', {
						params: { id },
						heading: 'Edit Distribution List',
						width: 900,
						height: 'full',
					})
					.then(refresh, refresh);
			});
		});
	}

	edit(list) {
		window.location.href = this.$state.href('hub.loggedin.EmailDistListEdit', { id: list.id });
	}

	delete(list) {
		const msg = `Are you sure you want to delete "${_.escape(list.name)}"?`;
		this.modal.confirm({ escapedHtml: msg }).then(() => {
			this.lists = _.without(this.lists, list);
			this.filters.cb = _.uniqueId();
			this.Api.delete(`/distribution_lists/${list.id}`);
		});
	}

	provideLists(params) {
		let lists = this.lists.slice(0);
		lists = _.sortBy(lists, params.sort.replace(/^-/, ''));
		if (params.sort.slice(0, 1) == '-') {
			lists.reverse();
		}
		const offset = (params.page - 1) * params.limit;
		lists = lists.slice(offset, offset + params.limit);
		return {
			data: lists,
			total: this.lists.length,
		};
	}

	refresh() {
		this.Api.get('/distribution_lists').then(lists => {
			this.lists = ensure.array(lists).filter(list => list.is_active);
			this.filters.cb = _.uniqueId();
		});
	}
}
